<template>

    <div class="panel" :class="{collapsed: collapsed, collapsible: collapsible}">
        <div class="title" :class="{pointer: collapsible}" @click="toggleCollapse()">
            {{title}}
            <svgicon v-if="collapsible" src="/icon/arrow.svg" class="titleChevron" :class="{collapsed: collapsed}" width="20"></svgicon>
        </div>
        <div class="content">
            <div class="content-inner">
                <slot></slot>
            </div>
        </div>
    </div>

</template>

<script>

    export default {

        name: "Panel",

        props: {
            collapsible: Boolean,
            title: String
        },

        data() {
            return {
                collapsed: false
            }
        },

        methods: {
            toggleCollapse() {
                if (this.collapsible) {
                    this.collapsed = !this.collapsed;
                }
            }
        }
    };

</script>

<style lang="scss" scoped>

    .panel {
        background-color: white;
        border-radius: 2px;
        padding: 30px 40px;
        margin-bottom: 20px;

        & > .title {
            font-weight: bold;
            font-size: 20px;
            line-height: 1;
            padding-bottom: 8px;
            border-bottom: 1px solid #f2f3f4;
            position: relative;
            user-select: none;
            color: #001722;
        }
        .content-inner {
            padding-top: 30px;
        }
        .subtitle {
            text-transform: uppercase;
            font-weight: bold;
            font-size: 14px;
            color: inherit;
            margin-bottom: 20px;
            line-height: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .actions {
            margin-top: 30px;
        }

        .pointer {
            cursor: pointer;
        }

        &.collapsible {

            .titleChevron {
                fill: #d9d9d9;
                position: absolute;
                right: 0;
                top: 4px;
                transition: transform 0.3s ease-in-out;
                transform: rotateZ(180deg);
            }
            &.collapsed {
                .titleChevron {
                    transform: none;
                }
                .content {
                    opacity: 0;
                    max-height: 0;
                    visibility: collapse;
                }
            }
            .content {
                transition: max-height 0.2s, opacity 0.2s, visibility 0.2s;
                max-height: 10000px;
            }
        }
    }

</style>